
























import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import PromotionItemSelector from "./PromotionItemSelector.vue";
import {
  PromotionItemGroupForm,
  PromotionItemForm
} from "../forms/PromotionCreateForm";
export default Vue.extend({
  components: {
    PromotionItemSelector
  },
  props: {
    value: {
      type: Object as () => PromotionItemGroupForm,
      default: () => {
        return { items: [], deletedItemsId: [] };
      }
    },
    placeholder: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean
    },
    isDisable: {
      type: Boolean
    },
    validations: {
      type: Object
    }
  },
  computed: {
    ...proxyModel("items", "deletedItemsId")
  },
  methods: {
    remove() {
      this.$emit("remove");
      this.$emit("removeItemGroup");
    },
    checkItem() {
      this.$emit("checkItem");
    },
    removeItem(e: number) {
      (this as any).deletedItemsId.push(e);
    }
  }
});
